import { useMemo } from 'react';
import { buildImgixSrcSet, isImgixUrl } from './buildImgixSrcSet';
import { useImageTransform } from './ImageTransformContext';
import { StyledImage } from './EntityImage.styles';
import type { EntityImageProps } from './EntityImage.types';

export function EntityImage({
  src,
  alt = '',
  loading = 'lazy',
  transform,
  sizing,
  ...rest
}: EntityImageProps) {
  const contextTransform = useImageTransform();
  const applyTransform = transform ?? contextTransform;

  const { resolvedSrc, srcSet } = useMemo(() => {
    const resolved = src && applyTransform && !isImgixUrl(src) ? applyTransform(src, sizing) : src;
    return { resolvedSrc: resolved, srcSet: buildImgixSrcSet(resolved) };
  }, [src, applyTransform, sizing]);

  return (
    <StyledImage
      src={resolvedSrc}
      srcSet={srcSet}
      alt={alt}
      loading={loading}
      decoding="async"
      {...rest}
    />
  );
}
